// extracted by mini-css-extract-plugin
export default {"entire-container":"NotFound_entire-container__pzL1v","text-btn-container":"NotFound_text-btn-container__ZsuPh"};